import React, { Component } from "react";
import { connect } from "react-redux";
import TreeTableWithSlider from "../../../common/treeTableWithSlider";

class UniverseAnalyzeTreeTableHolder extends Component {
  componentWillMount() {
    const {
      asset_class,
      overall_focus,
      styles,
      getScenarioShortlist,
      optimization_params,
      activePortfolioID,
    } = this.props;

    this.validate_and_reset_backendparams_limits({
      overall_focus,
      asset_class,
      styles,
      symbols: getScenarioShortlist,
      upper_bounds:
        optimization_params &&
        activePortfolioID &&
        optimization_params[activePortfolioID]["upper_bounds"],
    });
  }
  componentWillReceiveProps(nextProps) {
    const {
      asset_class,
      overall_focus,
      styles,
      getScenarioShortlist,
      optimization_params,
      activePortfolioID,
    } = nextProps;

    if (
      JSON.stringify(this.props.getScenarioShortlist) !==
        JSON.stringify(getScenarioShortlist) ||
      this.props.activePortfolioID !== nextProps.activePortfolioID
    ) {
      this.validate_and_reset_backendparams_limits({
        overall_focus,
        asset_class,
        styles,
        symbols: getScenarioShortlist,
        upper_bounds:
          optimization_params &&
          activePortfolioID &&
          optimization_params[activePortfolioID]["upper_bounds"],
      });
    }
  }

  // resetting create backend_params
  // if no associated data present in scenario_short_symbols from
  // asset_class, classification, style
  // then resetting min,max of above - limits
  validate_and_reset_backendparams_limits = ({
    overall_focus,
    asset_class,
    styles,
    symbols,
    upper_bounds,
  }) => {
    // except asset_class resetting other types
    // asset_class
    // for (let i = 0; i < overall_focus.length; i++) {
    //   let name = overall_focus[i]["name"]
    //     ? overall_focus[i]["name"].toLowerCase()
    //     : "";
    //   let filtered_asset =
    //     symbols && symbols.length > 0
    //       ? symbols.filter((obj) =>
    //           obj.fund_asset_class_focus
    //             ? obj.fund_asset_class_focus.toLowerCase()
    //             : "" == name
    //         )
    //       : [];

    //   if (filtered_asset.length === 0) {
    //     let min = 0,
    //       max = 0,
    //       group = "overall_focus";
    //     let obj = { min, max, name, group };
    //     this.props.commonSliderHandler(obj);
    //   }
    // }
    //classification
    for (let i = 0; i < asset_class.length; i++) {
      let name = asset_class[i]["name"];
      let filtered_classification = symbols.filter(
        (obj) => obj.new_classification == name
      );

      if (filtered_classification.length === 0) {
        let min = 0,
          max = 0,
          group = "asset_class";
        let obj = { min, max, name, group };
        this.props.commonSliderHandler(obj);
      } else {
        let min = 0,
          max = 0,
          group = "asset_class";

        max = (upper_bounds * filtered_classification.length).toFixed(2);
        if (max > 100) max = 100;

        let obj = { min, max, name, group };
        this.props.commonSliderHandler(obj);
      }
    }
    //styles
    for (let i = 0; i < styles.length; i++) {
      let name = styles[i]["style"];
      let filtered_styles = symbols.filter((obj) => obj.new_style == name);
      if (filtered_styles.length === 0) {
        let min = 0,
          max = 0,
          group = "styles";
        let obj = { min, max, name, group };
        this.props.commonSliderHandler(obj);
      } else {
        let min = 0,
          max = 0,
          group = "styles";

        max = (upper_bounds * filtered_styles.length).toFixed(2);
        if (max > 100) max = 100;

        let obj = { min, max, name, group };
        this.props.commonSliderHandler(obj);
      }
    }
  };
  render() {
    const {
      activePortfolioID,
      getScenarioShortlist,
      overall_focus,
      asset_class,
      styles,
      optimization_params,
      validate_slider_limits,
      portfolioActive,
      securityUniverseActive,
      commonSliderHandler,
      coreAllocationHandler,
      setFundTypeStyleError,
    } = this.props;

    return (
      <TreeTableWithSlider
        activePortfolioID={activePortfolioID}
        getScenarioShortlist={getScenarioShortlist}
        overall_focus={overall_focus}
        asset_class={asset_class}
        styles={styles}
        optimization_params={optimization_params}
        setDualSliderValues={(obj) => commonSliderHandler(obj)}
        validate_slider_limits={validate_slider_limits}
        setFundTypeStyleError={setFundTypeStyleError}
        minMaxZeroToHundred={true}
        allocationInputField={true}
        allocationHandler={coreAllocationHandler}
        allocation_max_limit={
          optimization_params[activePortfolioID]["upper_bounds"]
        }
        deleteRow={true}
        listOfSecuritiesToDelete={this.props.listOfSecuritiesToDelete}
        undoListOfSecuritiesToDelete={this.props.undoListOfSecuritiesToDelete}
        single_asset_class_style={true}
        apply_max_to_allocation_ip={false}
        universeLiteValidation={true}
        ownSecurityUniverse={
          portfolioActive && securityUniverseActive ? true : false
        }
        original_allocation_display={true}
      />
    );
  }
}

export default connect(
  ({
    create: {
      steps: {
        universeLite: { portfolioActive, securityUniverseActive },
      },
    },
  }) => ({
    portfolioActive,
    securityUniverseActive,
  }),
  (dispatch) => ({
    commonSliderHandler: (payload) =>
      dispatch({
        type: "SET_CREATEPORTFOLIO_COMMON_LIMIT_SLIDER",
        payload,
      }),
    setFundTypeStyleError: (value) =>
      dispatch({ type: "SET_FUNDTYPE_ERROR", payload: value }),

    coreAllocationHandler: ({ symbol, value }) =>
      dispatch({
        type: "SET_ANALYZE_MERGED_ALLOCATION_VALUE_NEW",
        payload: { symbol, value },
      }),
    listOfSecuritiesToDelete: (payload) =>
      dispatch({
        type: "DELETE_ANALYZE_MERGED_PORTFOLIOS",
        payload,
      }),
    undoListOfSecuritiesToDelete: (payload) =>
      dispatch({
        type: "UNDO_DELETE_ANALYZE_MERGED_PORTFOLIOS",
        payload,
      }),
  })
)(UniverseAnalyzeTreeTableHolder);



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/UniverseAnalyzeTreeTableHolder.jsx